class ConfiguratorSizeFabricSize {
    constructor() {
        console.log("[SIZE-FABRIC-SIZE] Constructor initialized");
        this.id = 'sizefabricsize';
        this.cache = {};
        this.selectors = ['size', 'fabric', 'panelsize']; 
        
        // Maps headboard size → panel size for every product family
        this.panelSizeMap = {
            otterosalo: {
                '156': ['150'],
                '186': ['180'],
                '216': ['210'],
                '252': ['150'],
                '218': ['210'],
                '282': ['180'],
                '312': ['210']
            },
            pinnosalo: {
                '158': ['150'],                
                '186': ['180'],     // Regular pinnosalo sizes
                '218': ['210'], 
                '282': ['150', '180', '210'],
                '282 ST': ['180'],  // Special case with side table
            }
        };
        
        // Maintain backward compatibility
        this.otterosaloMapping = this.panelSizeMap.otterosalo;
        
        for (const sel of this.selectors) {
            console.log(`[SIZE-FABRIC-SIZE] Registering selector: ${sel}`);
            configurator.addSelectorItem(sel);
        }
                
        this.init();
    }

    async init() {
        console.log("[SIZE-FABRIC-SIZE] Initializing component");
        // Pre-load default fabric data for faster initial rendering
        const defaultFabric = this.getDefaultFabric();
        if (defaultFabric) {
            configurator.selection['fabric'] = defaultFabric;
            this.setDefaults(configurator.selection.fabric);
            await this.loadBuyables(defaultFabric);
        }
    }

    async refresh(selector) {
        console.log(`[SIZE-FABRIC-SIZE] Refreshing with selector: ${selector}`);
        console.log(`[SIZE-FABRIC-SIZE] Current selection before refresh logic:`, JSON.stringify(configurator.selection));

        // Apply mapping when size changes (one-way only)
        if (selector === 'size' && configurator.selection.size) {
            this.applySizeToPanelMapping();
        }

        console.log(`[SIZE-FABRIC-SIZE] Selection after mapping logic:`, JSON.stringify(configurator.selection));

        // Set default fabric if none selected
        if (!configurator.selection['fabric']) {
            const defaultFabric = this.getDefaultFabric();
            console.log(`[SIZE-FABRIC-SIZE] No fabric selected, defaulting to ${defaultFabric}`);
            configurator.selection['fabric'] = defaultFabric;
        }
        
        // Load buyables if needed
        if (!(configurator.selection.fabric in this.cache)) {
            console.log(`[SIZE-FABRIC-SIZE] Loading buyables for fabric: ${configurator.selection.fabric}`);
            await this.loadBuyables(configurator.selection.fabric);
        } else {
            console.log(`[SIZE-FABRIC-SIZE] Using cached data for fabric: ${configurator.selection.fabric}`);
        }
        
        // Always ensure a valid combination for the current cache
        this.setDefaults(configurator.selection.fabric);
        
        // Populate selectors
        this.populateHeadSizes();
        this.populateFabrics();
        this.populatePanelSizes();
        
        console.log(`[SIZE-FABRIC-SIZE] After refresh - selection:`, JSON.stringify(configurator.selection));
    }
       
    getDefaultFabric() {
        // Print debug info about bed_configuration
        console.log(`[FABRIC-DEBUG] bed_configuration:`, JSON.stringify(bed_configuration));
        
        // Try to use a configured default fabric if available
        if (bed_configuration.default_fabric) {
            console.log(`[FABRIC-DEBUG] Using configured default_fabric: ${bed_configuration.default_fabric}`);
            return bed_configuration.default_fabric;
        }
        
        // Print available fabrics from m3_fabrics
        console.log(`[FABRIC-DEBUG] m3_fabrics contains ${Object.keys(configurator.m3_fabrics).length} fabrics`);
        
        // List first 5 fabrics with their details
        let count = 0;
        for (const key in configurator.m3_fabrics) {
            if (count < 5) {
                console.log(`[FABRIC-DEBUG] Fabric ${key}: ${JSON.stringify(configurator.m3_fabrics[key])}`);
                count++;
            }
            
            if (configurator.m3_fabrics[key][3] == 1) {
                console.log(`[FABRIC-DEBUG] Found enabled fabric: ${key}`);
                return key;
            }
        }
        
        // Fallback to hardcoded default only as last resort
        console.log(`[FABRIC-DEBUG] Falling back to hardcoded fabric: 0LLG`);
        return '0LLG';
    }

    getDefaultPanel() {
        
        // Try to use a configured default fabric if available
        if (bed_configuration.default_panel) {
            console.log(`[PANEL-DEBUG] Using configured default_panel: ${bed_configuration.default_panel}`);
            return bed_configuration.default_panel;
        }       
        return '180';
    }
    
    isValidSelector(selector) {
        const isValid = this.selectors.includes(selector);
        console.log(`[SIZE-FABRIC-SIZE] Checking if selector is valid: ${selector} = ${isValid}`);
        return isValid;
    }
    
    // Check if current product is otterosalo
    isOtterosalo() {
        // First check the category field directly, which is the most reliable indicator
        if (bed_configuration && bed_configuration.category === 'otterosalo') {
            return true;
        }
        
        // Fallback to checking other fields
        const str = (
            bed_configuration?.product ||
            bed_configuration?.handle  ||
            ''
        ).toString().toLowerCase();
        return str.includes('otterosalo');
    }
    
    // Check if current product is pinnosalo
    isPinnosalo() {
        // First check the category field directly, which is the most reliable indicator
        if (bed_configuration && bed_configuration.category.includes('pinnosalo')) {
            return true;
        }
        
        // Fallback to checking other fields
        const str = (
            bed_configuration?.product ||
            bed_configuration?.handle  ||
            ''
        ).toString().toLowerCase();
        return str.includes('pinnosalo');
    }
    
    // Get the current product family
    getCurrentFamily() {
        if (this.isOtterosalo()) return 'otterosalo';
        if (this.isPinnosalo()) return 'pinnosalo';
        return 'default';
    }
    
    // Get the active mapping based on current product family
    getActiveMapping() {
        return this.panelSizeMap[this.getCurrentFamily()] || {};
    }
    
    // Ensure we use the correct lookup key format
    normaliseSizeKey(size) {
        if (!size) return '';
        
        // If it's a side table variant, keep the "ST" suffix
        if (size.trim().endsWith('ST')) {
            return size.trim();
        }
        
        // For normal sizes, extract just the first part (before x or space)
        // For example: "186x149" becomes "186", "282 cm" becomes "282"
        return size.split(' ')[0].split('x')[0];
    }
    
    // Check if a product ID indicates a side table variant
    hasSideTable(productId) {
        return productId && productId.toString().endsWith('ST');
    }
    
    setupListeners() {
        console.log("[SIZE-FABRIC-SIZE] Setting up listeners (none needed)");
        // No specific listeners needed
    }

    // Apply mapping from size to panel (one-way only)
    applySizeToPanelMapping() {
        const size = configurator.selection.size;
        if (!size) return;

        // Unified mapping approach for all product types
        const sizeKey = this.normaliseSizeKey(size);
        const productFamily = this.getCurrentFamily();
        const mapping = this.getActiveMapping();
        
        console.log(`[SIZE-FABRIC-SIZE] Mapping product family: ${productFamily}, size key: ${sizeKey}, available mappings:`, JSON.stringify(Object.keys(mapping)));
        
        const panel = mapping[sizeKey];
        if (panel) {
            configurator.selection.panelsize = panel[0];
            console.log(`[SIZE-FABRIC-SIZE] Mapping ${size} → panel ${panel}`);
        } else {
            console.log(`[SIZE-FABRIC-SIZE] No panel mapping for ${size} (key: ${sizeKey}) in ${productFamily}`);
        }
    }
    
    async loadBuyables(fabric) {
        console.log(`[SIZE-FABRIC-SIZE] Loading buyables for fabric: ${fabric}`);
        
        // Use bed_configuration for collection and category, similar to furniture configurator
        const collection = bed_configuration.collection || 'headboards';
        const category = bed_configuration.category || 'headboards';
        
        console.log(`[SIZE-FABRIC-SIZE] Using collection: configurator-${collection}, category: ${category}`);
        
        // Prepare filters based on configuration
        const filters = [
            { key: 'category', value: category }
        ];
        
        if (fabric) {
            filters.push({ key: 'fabric', value: fabric });
        }
        
        console.log(`[SIZE-FABRIC-SIZE] Filters for loadProductData:`, JSON.stringify(filters));
        
        try {
            // Load product data from Shopify collection
            const products = await configurator.loadProductData(
                'configurator-' + collection,
                filters,
                ['size', 'panel_size', 'fabric', 'width', 'height', 'length'],
                true
            );
            
            console.log(`[SIZE-FABRIC-SIZE] Loaded ${products.length} products from Shopify`);
            
            // DEBUG: Print the first product if available
            if (products.length > 0) {
                console.log(`[PRODUCT-DEBUG] First product:`, JSON.stringify(products[0]));
                console.log(`[PRODUCT-DEBUG] Available fabrics in products:`, products.map(p => p.fabric).filter((v, i, a) => a.indexOf(v) === i));
            } else {
                // If no products were found, let's try to find out why
                console.log(`[PRODUCT-DEBUG] No products found. Testing query with just category filter...`);
                const testProducts = await configurator.loadProductData(
                    'configurator-' + collection,
                    [{ key: 'category', value: category }],
                    ['size', 'panel_size', 'fabric', 'width', 'height', 'length'],
                    true
                );
                console.log(`[PRODUCT-DEBUG] Test query returned ${testProducts.length} products`);
                if (testProducts.length > 0) {
                    console.log(`[PRODUCT-DEBUG] Available fabrics in test products:`, testProducts.map(p => p.fabric).filter((v, i, a) => a.indexOf(v) === i));
                }
            }
            // Process and cache data in a nested structure:
            // cache[fabric] = { sizes: { size1: { panels: { panel1: item } } } }
            for (const product of products) {
                const size = product.size;
                const panel_size = product.panel_size;
                let modifiedSize = size;
                if (this.isPinnosalo() && size.startsWith('282') && this.hasSideTable(product.id)) {
                    // Modify the size to include ST suffix
                    modifiedSize = '282 ST';
                    console.log(`[SIZE-FABRIC-SIZE] Identified pinnosalo side table variant: ${product.id}, setting size to ${modifiedSize}`);
                }
                
                console.log(`[SIZE-FABRIC-SIZE] Processing product - size: ${modifiedSize}, panel: ${panel_size}, fabric: ${fabric}`);
                
                if (!this.cache[fabric]) {
                    this.cache[fabric] = { sizes: {} };
                }
                
                if (!this.cache[fabric].sizes[modifiedSize]) {
                    this.cache[fabric].sizes[modifiedSize] = { panels: {} };
                }
                
                const variant = product.variants[0];
                const item = configurator.variantToItem(product, variant);
                // Safely calculate dimensions, defaulting to 0 if any value is missing
                item.dimensions = [
                    this.safelyDivideToCm(product.width), 
                    this.safelyDivideToCm(product.length), 
                    this.safelyDivideToCm(product.height)
                ];
                item.size = modifiedSize;
                item.panel_size = panel_size;
                
                this.cache[fabric].sizes[modifiedSize].panels[panel_size] = item;
                
                console.log(`[SIZE-FABRIC-SIZE] Cached item - size: ${modifiedSize}, panel: ${panel_size}, price: ${item.price}`);
            }
            
            console.log(`[SIZE-FABRIC-SIZE] Cache structure after loading:`, JSON.stringify(Object.keys(this.cache)));
            if (this.cache[fabric]) {
                console.log(`[SIZE-FABRIC-SIZE] Sizes for fabric ${fabric}:`, JSON.stringify(Object.keys(this.cache[fabric].sizes)));
            }
            
            // Set defaults if needed
            this.setDefaults(fabric);
        } catch (error) {
            console.error(`[SIZE-FABRIC-SIZE] Error loading product data: ${error.message}`);
        }
    }
    
    // Helper to safely convert mm to cm, handling null/undefined
    safelyDivideToCm(value) {
        if (!value || isNaN(parseFloat(value))) return 0;
        return parseFloat(value) / 10;
    }
    
    setDefaults(fabric) {
        console.log(`[SIZE-FABRIC-SIZE] Setting defaults for fabric: ${fabric}`);
        
        if (!this.cache[fabric] || !this.cache[fabric].sizes) {
            console.log(`[SIZE-FABRIC-SIZE] No cached data for fabric ${fabric}, can't set defaults`);
            return;
        }
        
        const availableSizes = Object.keys(this.cache[fabric].sizes);
        console.log(`[SIZE-FABRIC-SIZE] Available headboard sizes:`, JSON.stringify(availableSizes));
        
        // If size is not set or is invalid for this fabric, set a default
        if (!configurator.selection.size || !availableSizes.includes(configurator.selection.size)) {
            if (availableSizes.length > 0) {
                // For pinnosalo, prioritize non-ST variants as defaults
                if (this.isPinnosalo()) {
                    const nonStSizes = availableSizes.filter(size => !size.includes('ST'));
                    if (nonStSizes.length > 0) {
                        configurator.selection.size = nonStSizes[0];
                    } else {
                        configurator.selection.size = availableSizes[0];
                    }
                    console.log(`[SIZE-FABRIC-SIZE] Pinnosalo product - set prioritized default size: ${configurator.selection.size}`);
                } else {
                    configurator.selection.size = availableSizes[0];
                    console.log(`[SIZE-FABRIC-SIZE] Set default size: ${configurator.selection.size}`);
                }
            }
        }
        
        if (!this.cache[fabric].sizes[configurator.selection.size]) {
            console.log(`[SIZE-FABRIC-SIZE] Size ${configurator.selection.size} not available for fabric ${fabric}`);
            return;
        }
        
        const availablePanels = Object.keys(this.cache[fabric].sizes[configurator.selection.size].panels);
        console.log(`[SIZE-FABRIC-SIZE] Available panel sizes:`, JSON.stringify(availablePanels));
        
        // Unified approach for applying panel mapping
        const sizeKey = this.normaliseSizeKey(configurator.selection.size);
        const mapped = this.getActiveMapping()[sizeKey];
        if (mapped && availablePanels.includes(mapped)) {
            configurator.selection.panelsize = mapped;
            console.log(`[SIZE-FABRIC-SIZE] Applied mapping: ${configurator.selection.size} → panel ${mapped}`);
        }
        
        // If panelsize is not set or is invalid for this size+fabric combination, set a default
        if (!configurator.selection.panelsize || !availablePanels.includes(configurator.selection.panelsize)) {
            if (availablePanels.length > 0) {
                configurator.selection.panelsize = availablePanels[0];
                console.log(`[SIZE-FABRIC-SIZE] Set default panelsize: ${configurator.selection.panelsize}`);
            }
        }
        
        console.log(`[SIZE-FABRIC-SIZE] After setDefaults - selection:`, JSON.stringify(configurator.selection));
    }
    
    populateFabrics() {
        console.log(`[SIZE-FABRIC-SIZE] Populating fabrics`);
        const items = [];
        
        for (const key in configurator.m3_fabrics) {
            if (configurator.m3_fabrics[key][3] != 1) { continue; }
            
            const thumbnail = configurator.getSwatch(configurator.m3_fabrics[key][0]);
            const item = {
                'id': key,
                'label': configurator.m3_fabrics[key][1],
                'thumbnail': thumbnail,
                'group_by': configurator.m3_fabrics[key][2],
                'available': true,
            };
            
            items.push(item);
        }
        
        console.log(`[SIZE-FABRIC-SIZE] Rendering ${items.length} fabric options`);
        
        configurator.renderSelector('fabric', items, {
            'thumbnails': true,
            'allow_none': false,
        });
    }
    
    populateHeadSizes() {
        console.log(`[SIZE-FABRIC-SIZE] Populating headboard sizes`);
        const items = [];
        const fabric = configurator.selection.fabric;
        
        if (!this.cache[fabric] || !this.cache[fabric].sizes) {
            console.log(`[SIZE-FABRIC-SIZE] No sizes available for fabric: ${fabric}`);
            return;
        }
        
        for (const size in this.cache[fabric].sizes) {
            // Check if this is a pinnosalo side table variant
            let label = size;
            if (size === '282 ST') {
                label = '282 with Side Table';
            } else {
                label = size + ' cm';
            }
            
            items.push({
                'id': size,
                'label': label,
                'thumbnail': null,
                'available': true,
            });
        }
        
        // Sort items numerically based on the first number in the size
        // but keep ST variants next to their non-ST counterparts
        items.sort((a, b) => {
            // Extract the numerical part from the size
            const aNum = parseInt(a.id.split(' ')[0]);
            const bNum = parseInt(b.id.split(' ')[0]);
            
            // If the numerical parts are the same, sort "ST" variant second
            if (aNum === bNum) {
                return a.id.includes('ST') ? 1 : -1;
            }
            
            // Otherwise sort by numerical value
            return aNum - bNum;
        });
        
        console.log(`[SIZE-FABRIC-SIZE] Rendering ${items.length} headboard size options in numerical order`);
        
        configurator.renderSelector('size', items, {
            'columns': 4,
            'allow_none': false,
        });
        configurator.updateSelectorState('size');
    }
    
    populatePanelSizes() {
        console.log(`[SIZE-FABRIC-SIZE] Populating panel sizes`);
        const items = [];
        const fabric = configurator.selection.fabric;
        const size = configurator.selection.size;
        if (!this.cache[fabric] || 
            !this.cache[fabric].sizes || 
            !this.cache[fabric].sizes[size] || 
            !this.cache[fabric].sizes[size].panels) {
            console.log(`[SIZE-FABRIC-SIZE] No panel sizes available for fabric: ${fabric}, size: ${size}`);
            return;
        }
        
        // Use a unified approach - get panels available for the current size
        const panelsToDisplay = Object.keys(this.cache[fabric].sizes[size].panels);
        console.log(`[SIZE-FABRIC-SIZE] Panels to display for size ${size}:`, JSON.stringify(panelsToDisplay));
        
        for (const panel of panelsToDisplay) {
            // Skip "null" or "default" panels for display
            if (panel === "null" || panel === "default") {
                continue;
            }
            
            items.push({
                'id': panel,
                'label': panel + ' cm',
                'thumbnail': null,
                'available': true,
            });
        }
        
        // If we have no items but have a default or null panel, use that
        if (items.length === 0 && 
            (panelsToDisplay.includes("default") || panelsToDisplay.includes("null"))) {
            const usePanel = panelsToDisplay.includes("default") ? "default" : "null";
            items.push({
                'id': usePanel,
                'label': this.isOtterosalo() ? 'Automatic' : usePanel,
                'thumbnail': null,
                'available': true,
            });
        }
        
        console.log(`[SIZE-FABRIC-SIZE] Rendering ${items.length} panel size options`);
        
        configurator.renderSelector('panelsize', items, {
            'columns': 4,
            'allow_none': false,
            'minimum_count': 2,
        });
        configurator.updateSelectorState('panelsize');
    }
    
    isSoldOut() {
        const fabric = configurator.selection.fabric;
        const size = configurator.selection.size;
        const panelsize = configurator.selection.panelsize;
        
        console.log(`[SIZE-FABRIC-SIZE] Checking if sold out - fabric: ${fabric}, size: ${size}, panelsize: ${panelsize}`);
        
        if (!this.cache[fabric] || 
            !this.cache[fabric].sizes || 
            !this.cache[fabric].sizes[size] || 
            !this.cache[fabric].sizes[size].panels || 
            !this.cache[fabric].sizes[size].panels[panelsize]) {
            console.log(`[SIZE-FABRIC-SIZE] Configuration not available in cache`);
            return true;
        }
        
        const item = this.cache[fabric].sizes[size].panels[panelsize];
        const soldOut = !(item && item.available);
        console.log(`[SIZE-FABRIC-SIZE] Sold out check result: ${soldOut}`);
        return soldOut;
    }
    
    getPriceData(priceData) {
        const fabric = configurator.selection.fabric;
        const size = configurator.selection.size;
        const panelsize = configurator.selection.panelsize;
        
        console.log(`[SIZE-FABRIC-SIZE] Getting price data - fabric: ${fabric}, size: ${size}, panelsize: ${panelsize}`);
        
        if (!this.cache[fabric] || 
            !this.cache[fabric].sizes || 
            !this.cache[fabric].sizes[size] || 
            !this.cache[fabric].sizes[size].panels || 
            !this.cache[fabric].sizes[size].panels[panelsize]) {
            console.log(`[SIZE-FABRIC-SIZE] Configuration not available for pricing`);
            return;
        }
        
        const item = this.cache[fabric].sizes[size].panels[panelsize];
        
        if (item) {
            console.log(`[SIZE-FABRIC-SIZE] Adding price: ${item.price}, SKUs: ${JSON.stringify(item.skus)}`);
            priceData.total += item.price ?? 0;
            if (Array.isArray(item.skus)) { priceData.skus.push(...item.skus); }
            if (Array.isArray(item.ids)) { priceData.ids.push(...item.ids); }
            
            // Show dimensions if available
            const dimensionsElement = document.querySelector('.dimensions');
            if (dimensionsElement && item.dimensions && item.dimensions.some(d => d > 0)) {
                dimensionsElement.querySelector('.dimensions-value').textContent = "B x L x H: " + item.dimensions.join(' x ') + " cm";
                dimensionsElement.hidden = false;
                console.log(`[SIZE-FABRIC-SIZE] Set dimensions: ${item.dimensions.join(' x ')} cm`);
            } else if (dimensionsElement) {
                dimensionsElement.hidden = true;
            }
            
            // Show SKU if available
            const skuElement = document.querySelector('.sku');
            if (skuElement && item.skus) {
                skuElement.innerHTML = item.skus.join(', ');
                console.log(`[SIZE-FABRIC-SIZE] Set SKU: ${item.skus.join(', ')}`);
            }
        }
    }
    
    getCylindoSpecs(specs) {
        console.log(`[SIZE-FABRIC-SIZE] Getting Cylindo specs`);
        // Set size feature (lowercase) with only numerical part
        if (configurator.selection.size) {
            // Handle special cases for Pinnosalo headboards
            console.log("Pinnosalo size: " + configurator.selection.size);
            let sizeValue = configurator.selection.size.split('x')[0];
            if (this.isPinnosalo() && sizeValue === '282') {
                const panelSizeMap282 = {
                    '150': '151,5',
                    '180': '181,5',
                    '210': '211,5'
                }
                const hasSideTable = configurator.selection.size.includes('ST');
                specs.features.size = `282 CM ${hasSideTable ? 'WITH' : 'WITHOUT'} SIDE TABLE WITH ${panelSizeMap282[configurator.selection.panelsize]} PANEL`;
                console.log(`[SIZE-FABRIC-SIZE] Set pinnosalo size feature with side table: ${specs.features.size}`);
            } else {
                // Remove " ST" if present
                sizeValue = sizeValue.replace(' ST', '');
                
                specs.features.size = sizeValue;
                console.log(`[SIZE-FABRIC-SIZE] Set size feature: ${sizeValue}`);
            }
        }
        
        // Set UPHOLSTERY feature
        if (configurator.selection.fabric) {
            // Print debug info about the selected fabric
            console.log(`[FABRIC-DEBUG] Selected fabric: ${configurator.selection.fabric}`);
            console.log(`[FABRIC-DEBUG] Fabric details: ${JSON.stringify(configurator.m3_fabrics[configurator.selection.fabric])}`);
            
            // Check if fabric exists in m3_fabrics
            if (configurator.m3_fabrics[configurator.selection.fabric]) {
                specs.features.UPHOLSTERY = configurator.m3_fabrics[configurator.selection.fabric][0];
                console.log(`[SIZE-FABRIC-SIZE] Set UPHOLSTERY feature: ${configurator.m3_fabrics[configurator.selection.fabric][0]}`);
            } else {
                console.error(`[FABRIC-ERROR] Fabric code ${configurator.selection.fabric} not found in m3_fabrics!`);
            }
        }
        
        console.log(`[SIZE-FABRIC-SIZE] Final Cylindo specs:`, JSON.stringify(specs.features));
    }
}

// Register the class globally - use the name that matches the id pushed to init_configurators
window['ConfiguratorSizefabricsize'] = ConfiguratorSizeFabricSize;